import { assignRef as f, createCallbackRef as n, mergeRefs as r, refToCallback as a, transformRef as R } from "use-callback-ref";
const o = {}, e = [], s = e;
export {
  f as assignRef,
  s as constDeps,
  e as constExoticDeps,
  o as constRef,
  n as createCallbackRef,
  r as mergeRefs,
  a as refToCallback,
  R as transformRef
};
